<template>
  <div class="box-edit left lefter" v-show="editor.mode == 'editing'">
    <div class="box-edit-line">
      <label>Localisation</label>
		<div class="flex">
			<input-autocomplete
			class="input"
			placeholder="Commune"
			itemtext="name"
			:value="localisation"
			@input="localisation = $event.item"
			:items="communes"
			:showonfocus="true"
			@query="debouncedGetVille"
			/>
		</div>
		<template v-for="loc in localisations">
			<div class="selected-commune"  :key="loc.id">
				<div :class="{'clear-selected-commune-enabled': localisations.length>1, 'clear-selected-commune-disabled': localisations.length<=1}" @click="clearSelectedCommune(loc.id)">
					<icon file="x" :size="24" class="q-mr-sm" />
				</div>
				{{loc.name}}
			</div>
		</template>
      
    </div>
    <div class="box-edit-line">
      <label class="label-edit">Type de bien</label>

      <div class="q-mb-sm">
        <q-checkbox :disable="type_biens.length == 1 && type_biens.includes('APARTMENT')" v-model="type_biens" val="APARTMENT" label="Appartement" dense />
      </div>
     	<q-checkbox :disable="type_biens.length == 1 && type_biens.includes('HOUSE')" v-model="type_biens" val="HOUSE" label="Maison" dense />
      <div>
        
      </div>
    </div>
    <div class="box-edit-line">
      <label>Période d'analyse des données</label>
      <div class="flex">
        <el-textarea
          :parent_data="active_study.etudeData.scpi.yanport[this.save_parent]"
          property="periode_analyse"
          :editable="true"
          format="number"
          placeholder="ex: 10"
          style="flex: 1 1 auto"
          class="q-mr-sm"
        />
        années
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InputAutocomplete from "@/components/global/input-autocomplete";
import study_utils from "@/libs/study_utils";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	mixins: [ PageMixin ],
	data: () => ({
		refreshing_yanport: false,
		communes: [],
		communesQuery: "",
		localisation: null,
		type_biens: []
	}),
	props: {
		save_parent: String
	},
	components: {
		InputAutocomplete,
	},
	computed: {
		...mapGetters([ "active_project", "active_study", "editor" ]),
		localisations: {
			get () {
				return this.active_study.etudeData.scpi.yanport[this.save_parent].localisations;
			},
			set: function (value) {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.scpi.yanport[this.save_parent],
					field: "localisations",
					value: value,
				});
			}
		},
		periode_analyse () {
			return this.active_study.etudeData.scpi.yanport[this.save_parent].periode_analyse;
		}
	},
	watch: {
		type_biens () {
			this.$store.dispatch("edit_object", {
				obj: this.active_study.etudeData.scpi.yanport[this.save_parent],
				field: "type_biens",
				value: this.type_biens,
			});
			this.refreshYanportData();
		},
		localisations () {
			this.refreshYanportData();
		},
		periode_analyse () {
			this.refreshYanportData();
		},
		localisation (newValue) {
			if(newValue != "" && newValue != null){
				this.addLoc(newValue);
			}
		}
	},
	created (){
		this.debouncedGetVille = this.debounce(event => {
			this.getVilles(event);
		}, 500);
		
	},
	async mounted (){
		this.getVilles(""); // initialize the dropdown list
		if(this.localisations.length == 0){
			// if there is not localisations, use the project's one
			const id = await study_utils.get_city_id(this.active_project.adresse.codeInsee);
			this.addLoc({"id": id,"name": this.active_project.adresse.ville});
		}
		let type_biens_saved = this.active_study.etudeData.scpi.yanport[this.save_parent].type_biens;
		if(typeof type_biens_saved == "string"){
			// RETROCOMPATIBILITY CHECK
			type_biens_saved = [type_biens_saved];
		}
		this.type_biens = type_biens_saved;
	},
	methods: {
		addLoc (value){
			let found = false;
			let i = 0;
			while(!found && i < this.localisations.length){
				// check if the localisation is already selected
				found = this.localisations[i].id === value.id;
				i++;
			}
			if(!found){
				const copyLocs = [...this.localisations];
				copyLocs.push(value);
				this.localisations = copyLocs;
			}else{
				alert("Cette localisation est déjà séléctionnée");
			}
		},
		async refreshYanportData () {
			this.refreshing_yanport = true;
			await this.$store.dispatch("refresh_yanport_data", { codeInsee: this.active_project.adresse.codeInsee}, this.parent_data );
			this.refreshing_yanport = false;
		},
		async getVilles (e) {
			const p = {
				q: e,
				lat: this.active_project.position.location.lat,
				lng: this.active_project.position.location.lon
			};
			const communes = await study_utils.get_yanport_villes(p);
			this.communes = communes.map(commune => ({
				value: { id: commune.id, name: commune.name },
				label: commune.name
			}));
		},
		clearSelectedCommune (idToDelete) {
			if(this.localisations.length > 1){
				let i = 0;
				let found = false;
				while(!found && i < this.localisations.length){
					found = this.localisations[i].id == idToDelete;
					i++;
				}
				if(found){
					const copyLocs = [...this.localisations];
					copyLocs.splice(i - 1, 1);
					this.localisations = copyLocs;
				}
			}
		},
		debounce (fn, delay) {
			let timeoutID = null;
			return function () {
				clearTimeout(timeoutID);
				const args = arguments;
				const that = this;
				timeoutID = setTimeout(function () {
					fn.apply(that, args);
				}, delay);
			};
		}
	}
};
</script>

<style lang="stylus">
.selected-commune
    background #eee
    padding 3px
    margin-top 3px

.clear-selected-commune-enabled
    cursor pointer
    display inline-block

.clear-selected-commune-disabled
    cursor default
    display inline-block
    opacity 0.2

</style>s